import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import store from 'store'
import { fetchTheme } from '../../actions/theme'
import { getTheme } from '../../reducers/theme'
import LoadingSpinner from '../LoadingSpinner'

const mapStateToProps = (state) => {
  return {
    theme: getTheme(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTheme() {
      return dispatch(fetchTheme())
    },
  }
}

@withRouter
@withTranslation()
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class MainWrapper extends Component {
  componentDidMount() {
    const { location, match, i18n } = this.props
    const queries = queryString.parse(location.search)
    if (Object.prototype.hasOwnProperty.call(match.params, 'schoolCode')) {
      store.set('schoolCode', match.params.schoolCode)
    } else {
      throw new Error('Not Found')
    }
    if (Object.prototype.hasOwnProperty.call(queries, 'accessToken')) {
      const { accessToken } = queries
      store.set('accessToken', accessToken)
    }
    if (Object.prototype.hasOwnProperty.call(queries, 'userId')) {
      const { userId } = queries
      store.set('userId', userId)
    }
    if (Object.prototype.hasOwnProperty.call(queries, 'locale')) {
      const { locale } = queries
      i18n.changeLanguage(locale)
    }
    if (Object.prototype.hasOwnProperty.call(queries, 'osType')) {
      const { osType } = queries
      store.set('osType', osType)
    }
    this.props.fetchTheme()
  }

  render() {
    const { theme, children } = this.props
    if (!theme) {
      return <LoadingSpinner />
    }
    return <div>{children}</div>
  }
}

MainWrapper.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
  fetchTheme: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  i18n: PropTypes.shape({
    changeLanguage: PropTypes.func.isRequired,
  }),
}

export default MainWrapper
